export default __webpack_public_path__ + "static/structural5-54d1edf7afd6f23f5047556eeddcd858.png";